export default [
    {
        path: 'relatorio-alto-custo-estatistico-cid',
        component: () => import(
            /* webpackChunkName: 'farmacia-relatorio-alto-custo-estatistico-cid' */
            '@/views/farmacia/relatorio-alto-custo-estatistico-cid/Index'
        ),
        redirect: 'relatorio-alto-custo-estatistico-cid/index',
        children: [
            {
                name: 'farmacia-relatorio-alto-custo-estatistico-cid-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-relatorio-alto-custo-estatistico-cid' */
                    '@/views/farmacia/relatorio-alto-custo-estatistico-cid/List.vue'
                ),
            },
        ],
    },
]